"use strict";
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrementLoadingState = exports.incrementLoadingState = void 0;
const loadingState_1 = require("../store/loadingState");
const incrementLoadingState = () => ({
    type: loadingState_1.LoadingStateActionTypes.INCREMENT_LOADING_STATE
});
exports.incrementLoadingState = incrementLoadingState;
const decrementLoadingState = () => ({
    type: loadingState_1.LoadingStateActionTypes.DECREMENT_LOADING_STATE
});
exports.decrementLoadingState = decrementLoadingState;
//# sourceMappingURL=LoadingState.js.map